module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout', [_c('div', {
    staticClass: "accueil-scene"
  }, [_c('div', {
    staticClass: "wrapper columns"
  }, [_c('div', {
    staticClass: "column is-10 is-offset-1"
  }, [(!_vm.isBookSelected) ? [_c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('h1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.search),
      expression: "!search"
    }],
    staticClass: "bigtitle"
  }, [_vm._v("Robert veut lire")])]), _c('search-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isBookSelected),
      expression: "!isBookSelected"
    }],
    on: {
      "input": _vm.onLivreSelect,
      "search": function($event) {
        _vm.search = arguments[0]
      }
    }
  }), _c('hr'), (_vm.user) ? _c('div', {
    staticClass: "box"
  }, [_c('h3', {
    staticClass: "title is-3",
    domProps: {
      "innerHTML": _vm._s(_vm.user.contexte.titre)
    }
  }), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.user.contexte.description)
    }
  })]) : _vm._e()] : [(_vm.loadingSuggestion) ? _c('loading') : _c('div', {
    staticClass: "suggestionwrapper"
  }, [_c('div', {
    staticClass: "containerr tr"
  }, [_c('router-link', {
    staticClass: "button is-float-right",
    attrs: {
      "tag": "button",
      "to": {
        name: 'intro'
      }
    }
  }, [_vm._v("Faire une nouvelle recherche")]), (_vm.livre) ? _c('book-cover', {
    staticClass: "bookselected mb3 mt3",
    attrs: {
      "id": _vm.livre.id,
      "skin": "preview"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "suggestions"
  }, [_c('transition-group', {
    staticClass: "columns is-multiline",
    attrs: {
      "tag": "ul",
      "name": "bounce",
      "stagger": "200",
      "appear": "appear"
    }
  }, _vm._l((_vm.suggestedTitreIds), function(id, index) {
    return _c('li', {
      key: index,
      staticClass: "column is-3-widescreen is-4-tablet is-6-mobile"
    }, [_c('div', {
      staticClass: "suggestionplaceholder"
    }, [(id) ? _c('book-rating', {
      staticClass: "bookrating",
      attrs: {
        "id": id,
        "contexte-id": _vm.contexteId
      },
      on: {
        "show-desc": _vm.showBookDesc
      }
    }) : _vm._e()], 1)])
  }))], 1)])]], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43320938"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accueil-scene.vue
// module id = 1361
// module chunks = 1